import { FC } from 'react'
import {
  Edit,
  SimpleForm,
  TextInput,
  required,
} from 'react-admin'

const GemeentenEdit: FC = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextInput source="naam" label="Naam" validate={required()} fullWidth />
      <TextInput source="gm_code" label="Gemeentecode" validate={required()} />
      <TextInput source="gm_naam" label="Gemeentenaam" validate={required()} fullWidth />
      <TextInput source="provincie" label="Provincie" fullWidth />
      <TextInput source="corop" label="COROP-regio" fullWidth />
    </SimpleForm>
  </Edit>
)

export default GemeentenEdit
